/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import {
  fetchDeployment,
  updateDeployment,
  resetUpdateDeployment,
} from '@/actions/stackDeployments'
import {
  fetchStackDeploymentRequest,
  updateStackDeploymentRequest,
} from '@/reducers/asyncRequests/registry'
import { getStackDeployment } from '@/reducers/stackDeployments'

import { withStackDeploymentRouteParams } from '../routing'

import EditStackDeploymentAdvancedPlanEditor, {
  ConsumerProps,
  DispatchProps,
  StateProps,
} from './EditStackDeploymentAdvancedPlanEditor'

import type { ReduxState } from '@/types/redux'

const mapStateToProps = (state: ReduxState, { stackDeploymentId }: ConsumerProps): StateProps => ({
  deployment: getStackDeployment(state, stackDeploymentId),
  fetchStackDeploymentRequest: fetchStackDeploymentRequest(state, stackDeploymentId),
  updateStackDeploymentRequest: updateStackDeploymentRequest(state, stackDeploymentId),
})

const mapDispatchToProps: DispatchProps = {
  fetchDeployment,
  updateDeployment,
  resetUpdateDeployment,
}

export default withStackDeploymentRouteParams<Pick<ConsumerProps, 'getInitialEditorState'>>(
  connect<StateProps, DispatchProps, ConsumerProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(EditStackDeploymentAdvancedPlanEditor),
)
